import { render, staticRenderFns } from "./ziInvestmentInfo.vue?vue&type=template&id=f6c98d74&scoped=true&"
import script from "./ziInvestmentInfo.vue?vue&type=script&lang=js&"
export * from "./ziInvestmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./ziInvestmentInfo.vue?vue&type=style&index=0&id=f6c98d74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c98d74",
  null
  
)

export default component.exports